// extracted by mini-css-extract-plugin
export default {"deleteIcon":"delete-confirm_deleteIcon__sIZhq"};